import { computed, ComputedRef } from 'vue';
import { useStore } from '@/store';
import { ICurrency, ISiteCurrencies } from '@store/interfaces/results/ISiteCurrencies';
import axios from 'axios';

interface IUseCurrencies {
  currencyList: ComputedRef<ISiteCurrencies | undefined>;
  selectedCurrency: ComputedRef<ICurrency | undefined>;
  changeCurrency: (currency: ICurrency) => Promise<void>;
}

type ISelectedCurrency = {
  path: string;
  action: string;
  LANGUAGE_ID: string;
  currencyId: number;
  siteCode: string;
};

export default function useCurrencies(): IUseCurrencies {
  const { state, commit } = useStore();
  const siteSettings = computed(() => state.results?.siteSettings);
  const currencyList = computed(() => state.results?.siteCurrencies);
  const selectedCurrency = computed(() => state.results?.siteCurrencies?.find((el) => el.active));
  const setUserSiteCurrency: ComputedRef<ISelectedCurrency | undefined> = computed(
    () => state.results?.routes?.siteCurrency?.setUserSiteCurrency
  );

  const changeCurrency = async (currency: ICurrency): Promise<void> => {
    try {
      if (setUserSiteCurrency.value) {
        commit('global/loaderStart');
        const { path, action } = setUserSiteCurrency.value;
        const response = await axios.post(path, {
          action,
          siteCode: siteSettings?.value?.siteCode,
          currencyId: currency.ID,
        });

        if (response.status === 200) {
          window.location.reload();
        }
      }
    } catch (err) {
      console.error();
      commit('global/loaderStop');
    }
  };

  return {
    currencyList,
    selectedCurrency,
    changeCurrency,
  };
}
